var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Link",
    clipPath: "url(#clip0_7345_19903)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 10L10 6",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.33398 3.99998L7.64265 3.64265C8.26785 3.01753 9.11578 2.66638 9.99989 2.66644C10.884 2.66651 11.7319 3.01778 12.357 3.64298C12.9821 4.26818 13.3333 5.11611 13.3332 6.00022C13.3331 6.88432 12.9819 7.7322 12.3567 8.35731L12.0007 8.66665",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.66611 12L8.40144 12.356C7.76894 12.9814 6.9153 13.3322 6.02578 13.3322C5.13625 13.3322 4.28261 12.9814 3.65011 12.356C3.33835 12.0477 3.09084 11.6807 2.92192 11.2761C2.753 10.8715 2.66602 10.4374 2.66602 9.99898C2.66602 9.56055 2.753 9.12647 2.92192 8.72188C3.09084 8.3173 3.33835 7.95025 3.65011 7.64198L3.99944 7.33331",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7345_19903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.816d53119dcae00d41c280b0b1e1d910.svg";
export { ForwardRef as ReactComponent };